import {useQuery} from "react-query";
import {useCallback} from "react";
import {apiV2} from "@/api/axiosConfig";

export function useGetModelStatus(type: string, id: string) {
    const fetchModelStatus = useCallback(async () => {
        const res = await apiV2.get<string>("item-status", {
            params: {id, type},
        });

        return res.data;

    },[type, id])


    const { data, refetch } = useQuery({
        queryKey: ["model-status", type, id],
        queryFn: fetchModelStatus,
        enabled: true,
        cacheTime: 5000,
    })

    return {data, refetch}
}

